// src/components/forms/fieldsConfig/bonCommandeFields.js

// Champs pour la création d'un bon de commande
export const bonCommandeCreationFields = [
  { 
    name: 'fournisseurId', 
    label: 'Fournisseur', 
    type: 'select', 
    required: true,
    options: [], // Rempli dynamiquement
    placeholder: 'Sélectionner un fournisseur',
    col: 12
  },
  { 
    name: 'source', 
    label: 'Source', 
    type: 'select', 
    required: true,
    options: [
      { value: 'manuel', label: 'Création manuelle' },
      { value: 'demandePrix', label: 'Demande de prix' },
      { value: 'devis', label: 'Devis client' }
    ],
    defaultValue: 'manuel',
    col: 6
  },
  { 
    name: 'dateLivraisonPrevue', 
    label: 'Date de livraison prévue', 
    type: 'date', 
    col: 6
  },
  { 
    name: 'adresseLivraison', 
    label: 'Adresse de livraison', 
    type: 'textarea', 
    rows: 2,
    placeholder: 'Adresse complète de livraison...',
    col: 12
  },
  { 
    name: 'technicienId', 
    label: 'Technicien assigné', 
    type: 'select', 
    options: [], // Rempli dynamiquement
    placeholder: 'Assigner un technicien (optionnel)',
    col: 6
  },
  { 
    name: 'notes', 
    label: 'Notes', 
    type: 'textarea', 
    rows: 3,
    placeholder: 'Notes internes sur la commande...',
    col: 12
  }
];

// Champs pour la mise à jour d'un bon de commande
export const bonCommandeUpdateFields = [
  ...bonCommandeCreationFields,
  { 
    name: 'statut', 
    label: 'Statut', 
    type: 'select', 
    required: true,
    options: [
      { value: 'brouillon', label: 'Brouillon' },
      { value: 'envoyé', label: 'Envoyé' },
      { value: 'confirmé', label: 'Confirmé' },
      { value: 'en_cours_livraison', label: 'En cours de livraison' },
      { value: 'livré_partiellement', label: 'Livré partiellement' },
      { value: 'livré', label: 'Livré' },
      { value: 'stocké_entrepot', label: 'Stocké entrepôt' },
      { value: 'reçu_fournisseur', label: 'Reçu fournisseur' },
      { value: 'reçu_technicien', label: 'Reçu technicien' },
      { value: 'assigné', label: 'Assigné' },
      { value: 'prêt_pour_technicien', label: 'Prêt pour technicien' },
      { value: 'intervention_en_cours', label: 'Intervention en cours' },
      { value: 'intervention_terminée', label: 'Intervention terminée' },
      { value: 'facturé', label: 'Facturé' },
      { value: 'clôturé', label: 'Clôturé' }
    ],
    defaultValue: 'brouillon',
    col: 6
  }
];

// Champs pour la réception fournisseur
export const bonCommandeReceptionFournisseurFields = [
  { 
    name: 'receptionFournisseur.confirme', 
    label: 'Confirmer la réception', 
    type: 'checkbox', 
    defaultValue: true
  },
  { 
    name: 'receptionFournisseur.quantiteRecue', 
    label: 'Quantité reçue', 
    type: 'number', 
    min: 0,
    placeholder: 'Quantité totale reçue'
  },
  { 
    name: 'receptionFournisseur.commentaire', 
    label: 'Commentaire', 
    type: 'textarea', 
    rows: 2,
    placeholder: 'État de la livraison, anomalies...'
  }
];

// Fonction pour formater les données bon de commande
export const formatBonCommandeData = (formData) => {
  const formattedData = {
    fournisseurId: formData.fournisseurId,
    source: formData.source,
    adresseLivraison: formData.adresseLivraison?.trim(),
    technicienId: formData.technicienId || undefined,
    notes: formData.notes?.trim()
  };

  // Gérer la date de livraison
  if (formData.dateLivraisonPrevue) {
    formattedData.dateLivraisonPrevue = formData.dateLivraisonPrevue;
  }

  // Si c'est une mise à jour, inclure le statut
  if (formData.statut) {
    formattedData.statut = formData.statut;
  }

  return formattedData;
};

// Fonction pour pré-remplir les données bon de commande
export const prepareBonCommandeFormData = (bonCommande) => {
  if (!bonCommande) return {};
  
  return {
    fournisseurId: bonCommande.fournisseurId?._id || bonCommande.fournisseurId || '',
    source: bonCommande.source || 'manuel',
    dateLivraisonPrevue: bonCommande.dateLivraisonPrevue 
      ? new Date(bonCommande.dateLivraisonPrevue).toISOString().split('T')[0] 
      : '',
    adresseLivraison: bonCommande.adresseLivraison || '',
    technicienId: bonCommande.technicienId?._id || bonCommande.technicienId || '',
    notes: bonCommande.notes || '',
    statut: bonCommande.statut || 'brouillon'
  };
};

// Fonction de validation
export const validateBonCommandeForm = (formData) => {
  const errors = {};
  
  if (!formData.fournisseurId) {
    errors.fournisseurId = 'Le fournisseur est obligatoire';
  }
  
  if (!formData.source) {
    errors.source = 'La source est obligatoire';
  }
  
  return errors;
};

export default {
  creation: bonCommandeCreationFields,
  update: bonCommandeUpdateFields,
  receptionFournisseur: bonCommandeReceptionFournisseurFields,
  format: formatBonCommandeData,
  prepare: prepareBonCommandeFormData,
  validate: validateBonCommandeForm
};